import {GAME_TYPES} from '../../constants/game';

/**
 * По правилам какого режима считается партия.
 *
 * Обычно это сам режим. Исключение — просмотр записи (REPLAY): запись сетевого
 * матча проигрывается по сетевым правилам (REPLAY ведет себя как ONLINE), а
 * запись локальной партии — например, прохождения обучения — по локальным.
 * Правила расходятся, например, в фазе расстановки: в локальной игре ее
 * завершают по очереди COMPLETE_PHASE, в сетевой — CONFIRM_SETUP_PHASE, и
 * локальная запись под сетевыми правилами застряла бы на расстановке.
 *
 * Режим правил записи выставляет тот, кто запускает просмотр (setGameType с
 * rulesGameType), — из самой записи он не выводится.
 */
export const getRulesGameType = (gameState) => {
  const gameType = gameState?.gameType ?? null;
  if (gameType === GAME_TYPES.REPLAY) {
    return gameState.replayRulesGameType ?? GAME_TYPES.REPLAY;
  }
  return gameType;
};
